/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CbsWelcome/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import ButtonIconSquare from 'DesignSystem/ButtonIconSquare/index'
import CaptchaInfo from 'DesignSystem/CaptchaInfo/index'
import CbsLogo from 'DesignSystem/Images/CbsLogo/index'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import viewPath from './viewPath.js'
import { animated, useSpring } from "@react-spring/web"



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function CbsWelcome({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/CbsWelcome"
  
}) {
  let isBefore = useIsBefore()
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let animatedVertical10 = useSpring({
"config": {
tension: 180,
friction: 12,
},
"delay": 250,
"from": {"scale": 1},
"to": {"scale": isBefore ? 0.75 : 1},
})
  return (<React.Fragment
>
<div
  data-testid="CbsWelcome.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-a2NH2': isBefore ? 0 : "1 linear"}}
 className={`views-block ${styles.Vertical}`}
>
<animated.div
  data-testid="CbsWelcome.Vertical:1"
  data-view-path={viewPath}
 style={{"--s-2-a2NH2": animatedVertical10.scale,}}
 className={`views-block ${styles.Vertical1}`}
>
<ButtonIconSquare
  viewPath={`${viewPath}/ButtonIconSquare`}
 onClick={onClick}
 marginTopText={40}
 text="Complete your profile"
 width={340}
 height={340}
>
{childProps => (
<CbsLogo
{...childProps}
  viewPath={`${viewPath}/CbsLogo`}
 width={300}
 height="auto"
/>
)}
</ButtonIconSquare>
<CaptchaInfo
  viewPath={`${viewPath}/CaptchaInfo`}
/>
</animated.div>
</div>
{children}
</React.Fragment>)
}